/**
 * The job number staff recognise.
 *
 * ServiceM8's `generated_job_id` is not an integer in this account. Half the
 * jobs are a branch prefix (`M1-4854`); a handful are lettered twins
 * (`20098A`). Those cannot live in `Job.number`, so they sit on
 * `displayNumber`. Numeric ids keep the hash so `#63533` still looks like a
 * job number; prefixed ids render as ServiceM8 issued them.
 *
 * Native FieldOps jobs have no generated id and show the serial. See
 * decision 37.
 */
export function formatJobNumber(job: {
  number: number
  displayNumber?: string | null
}): string {
  const raw = job.displayNumber?.trim()
  if (raw) return /^\d+$/.test(raw) ? `#${raw}` : raw
  if (job.number >= 1_000_000_000) return '—'
  return `#${job.number}`
}
